import {Ad} from "./ad";
import {IframeManager} from "./iframeManager";

export class Thumbnail extends Ad {

    constructor(context, containerId, parameters, ad) {
        super(context, containerId, parameters, ad);
        this.isAbsolute = parameters.isAbsolute;
        this.parentContainer = !parameters.isAbsolute ? parameters.parentContainer : this.context.document.body;
        this.parameters = Object.assign({}, this.constructor.getDefaultConfig(), this.parameters);
        this.config =  this.getPositionAndPercent();
    }

    static getDefaultConfig() {
        return {
            position: {
                gravity: "BottomRight", //BottomLeft , TopLeft , TopRight
                xMargin: 0,
                yMargin: 0
            },
            size: {
                width: "25%",
                height: "25%",
            }
        }
    }

    getStyleAttribute() {
        let yPositionKey = this.config.top ? "top" : "bottom";
        let xPositionKey = this.config.left ? "left" : "right";
        return `position: ${this.isAbsolute ? 'fixed' : 'absolute'}; z-index: 9999999999999; ${yPositionKey}: ${this.config[yPositionKey]}px; ${xPositionKey}: ${this.config[xPositionKey]}px;`;
    }

    build() {
        this.container.style.display = 'none';
        this.container.style.cssText = this.getStyleAttribute();
        this.iframeManager = new IframeManager(this);
        let iframe  = this.iframeManager.build()
        this.container.appendChild(iframe);
        this.iframeManager.addContent(this.ad.content);
        this.container.style.display = 'bock';
    };

    getPositionAndPercent() {
        let position = this.parameters.position;
        let size = this.parameters.size;
        let top = null;
        let bottom = null;
        let left = null;
        let right = null;
        let containerWidth = !this.isAbsolute ? this.parentContainer.clientWidth : this.context.innerWidth;
        let containerHeight = !this.isAbsolute && this.parentContainer.clientHeight > 0 ? this.parentContainer.clientHeight : this.context.innerHeight;

        if (position.gravity && position.gravity.includes('Top')) {
            top = position.yMargin.toString();
        }
        if (position.gravity && position.gravity.includes('Bottom')) {
            bottom = position.yMargin.toString();
        }

        switch (position.gravity) {
            case 'TopLeft':
            case 'BottomLeft':
                left = position.xMargin.toString();
                break;
            case 'TopRight':
            case 'BottomRight':
                right = position.xMargin.toString();
                break;
            default:
                bottom = "0";
                right = "0";
                break;
        }

        const config =  {
            "top": top,
            "left": left,
            "bottom": bottom,
            "right": right,
            "width":size.width,
            "height":size.height
        }

        Object.entries(config).forEach(([key, value]) => {
            if (value !== null && typeof value === "string" && value.indexOf('%') > -1) {
                let dimension = null;
                if (["top", "bottom", "height"].includes(key)) {
                    dimension = containerHeight;
                } else {
                    dimension = containerWidth;
                }
                config[key] = ((parseFloat(value) / 100) * dimension).toString();
            }

        });

        return config;
    };
}
